import React from "react";
import StockView from "../../Markets/StockView/StockView";

export default function StockList() {
  return (
    <>
      <div>
        <StockView />
      </div>
    </>
  );
}
